"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _style = require("../utils/style");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  height: 1px;\n  width: 18px;\n  background-color: ", ";\n  position: absolute;\n  left: 50%;\n  margin-left: -9px;\n  top: 50px;\n  animation: ", " ", "s ease infinite;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  height: 1px;\n  width: 18px;\n  background-color: ", ";\n  position: absolute;\n  left: 50%;\n  margin-left: -9px;\n  top: 30px;\n  animation: ", " ", "s ease infinite;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  height: 1px;\n  width: 18px;\n  background-color: ", ";\n  position: absolute;\n  left: 50%;\n  margin-left: -9px;\n  top: 10px;\n  animation: ", " ", "s ease infinite;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  height: 0;\n\twidth: 1px;\n\tborder-bottom: ", "px solid ", ";\n\tborder-left: 1px solid transparent;\n\tborder-right: 1px solid transparent;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  animation: ", " ", "s ease infinite;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  height: 0;\n\twidth: 1px;\n\tborder-bottom: ", "px solid ", ";\n\tborder-left: 1px solid transparent;\n\tborder-right: 1px solid transparent;\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  animation: ", " ", "s ease infinite;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  width: ", "px;\n  height: ", "px;\n  position: relative;\n  overflow: hidden;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  0%, \n  30% {\n    transform: translateY(68px);\n  }\n  40%,\n  80% {\n    transform: translateY(0);\n  }\n  90%,\n  100% {\n    transform: translateY(-68px);\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  0%, \n  20% {\n    transform: translateY(68px);\n  }\n  30%,\n  70% {\n    transform: translateY(0);\n  }\n  80%,\n  100% {\n    transform: translateY(-68px);\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  0%, \n  10% {\n    transform: translateY(68px);\n  }\n  20%,\n  60% {\n    transform: translateY(0);\n  }\n  70%,\n  100% {\n    transform: translateY(-68px);\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  0%, \n  40% {\n    transform: translateY(68px);\n  }\n  50%,\n  90% {\n    transform: translateY(0);\n  }\n  100% {\n    transform: translateY(-68px);\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    transform: translateY(68px);\n  }\n  10%,\n  50% {\n    transform: translateY(0);\n  }\n  60%,\n  100% {\n    transform: translateY(-68px);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var leftLadderMove = (0, _styledComponents.keyframes)(_templateObject());
var rightLadderMove = (0, _styledComponents.keyframes)(_templateObject2());
var RowLadderOneMove = (0, _styledComponents.keyframes)(_templateObject3());
var RowLadderTwoMove = (0, _styledComponents.keyframes)(_templateObject4());
var RowLadderThreeMove = (0, _styledComponents.keyframes)(_templateObject5());

var LoadContainer = _styledComponents.default.div(_templateObject6(), function (props) {
  return props.size === 'small' ? 16 : props.size === 'large' ? 24 : 20;
}, function (props) {
  return props.size === 'small' ? 60 : props.size === 'large' ? 68 : 64;
});

var LeftLadder = _styledComponents.default.div(_templateObject7(), function (props) {
  return props.size === 'small' ? 60 : props.size === 'large' ? 68 : 64;
}, function (props) {
  return props.color || '#00adb5';
}, leftLadderMove, function (props) {
  return props.speed || 4;
});

var RightLadder = _styledComponents.default.div(_templateObject8(), function (props) {
  return props.size === 'small' ? 60 : props.size === 'large' ? 68 : 64;
}, function (props) {
  return props.color || '#00adb5';
}, rightLadderMove, function (props) {
  return props.speed || 4;
});

var RowLadderOne = _styledComponents.default.div(_templateObject9(), function (props) {
  return props.color || '#00adb5';
}, RowLadderOneMove, function (props) {
  return props.speed || 4;
});

var RowLadderTwo = _styledComponents.default.div(_templateObject10(), function (props) {
  return props.color || '#00adb5';
}, RowLadderTwoMove, function (props) {
  return props.speed || 4;
});

var RowLadderThree = _styledComponents.default.div(_templateObject11(), function (props) {
  return props.color || '#00adb5';
}, RowLadderThreeMove, function (props) {
  return props.speed || 4;
});

var LadderLoading = function LadderLoading(_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? _style.commonStyle : _ref$style,
      color = _ref.color,
      speed = _ref.speed,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'default' : _ref$size;
  return _react.default.createElement(LoadContainer, {
    style: style
  }, _react.default.createElement(LeftLadder, {
    color: color,
    speed: speed,
    size: size
  }), _react.default.createElement(RightLadder, {
    color: color,
    speed: speed,
    size: size
  }), _react.default.createElement(RowLadderOne, {
    color: color,
    speed: speed,
    size: size
  }), _react.default.createElement(RowLadderTwo, {
    color: color,
    speed: speed,
    size: size
  }), _react.default.createElement(RowLadderThree, {
    color: color,
    speed: speed,
    size: size
  }));
};

var _default = LadderLoading;
exports.default = _default;